var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.detail.images, function(tt, ii) {
    var m0 = _vm.$getImg(tt)
    return {
      $orig: _vm.__get_orig(tt),
      m0: m0
    }
  })

  var m1 = require("static/sound/loc.png")

  var m2 = require("static/sound/like.png")

  var m3 = require("static/sound/unLike.png")

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        m1: m1,
        m2: m2,
        m3: m3
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }